import { Link } from 'react-router-dom'
import { t } from '@lingui/core/macro'

import { cn } from '@jotta/utils/css'

import SvgCaretLeft from '../generated/icons/SvgCaretLeft'
import { PlainBrandIcon } from '../Icons/BrandIcon/BrandIcon'

export function BackButton({
  location,
  className,
}: {
  location: string
  className?: string
}) {
  return (
    <Link
      to={location}
      className={cn('btn btn-tonal flex items-center gap-2', className)}
      aria-label={t`Back`}
    >
      <PlainBrandIcon icon={SvgCaretLeft} height={16} />
    </Link>
  )
}
